import React from 'react';
import {Route, Router, Switch} from '../node_modules/react-router-dom';
import history from './history';
import UserSearch from './user-search/UserSearch';
import UserProfile from './user-profile/UserProfile';
import Products from './products/Products';
import Accounts from './accounts/Accounts';
import AccountDetails from './accounts/account-details/AccountDetails';
import AccountApiProductDetails
    from './accounts/account-product-details/account-api-product-details/AccountApiProductDetails';
import Callback from "./authentication/Callback";
import PageNotFound from './errors/PageNotFound';
import ProductDetails from "./products/product-details/ProductDetails";
import AuthorizationService from "./services/authorization-service";

const auth = AuthorizationService.getInstance();

const handleAuthentication = (nextState, replace) => {
    if (/access_token|id_token|error/.test(nextState.location.hash)) {
        auth.handleAuthentication();
    }
};

const isAuthenticated = () => {
    if (!auth.isAuthenticated()) {
        auth.login();
        return <Callback />
    }
};

export const makeMainRoutes = () => {
    return (
        <Router history={history}>
            <Switch>
                <Route exact path="/" render={() => {
                    isAuthenticated();
                    if (auth.isAuthenticated()) {
                        history.replace('/accounts');
                    }
                    return null;
                }} />
                <Route exact path="/users" render={(props) => {
                    isAuthenticated();
                    return <UserSearch auth={auth} {...props} />
                }} />
                <Route exact path="/users/:id" render={(props) => {
                    isAuthenticated();
                    return <UserProfile auth={auth} {...props}/>
                }} />
                <Route exact path="/products" render={(props) => {
                    isAuthenticated();
                    return <Products auth={auth} {...props}/>
                }} />
                <Route exact path="/products/:id" render={(props) => {
                    isAuthenticated();
                    return <ProductDetails auth={auth} {...props}/>
                }} />
                <Route exact path="/callback" render={(props) => {
                    if (auth.isAuthenticated()) {
                        history.replace('/accounts');
                    }
                    handleAuthentication(props);
                    return <Callback />

                }}/>
                <Route exact path="/accounts" render={(props) => {
                    isAuthenticated();
                    return <Accounts auth={auth} {...props}/>
                }} />
                <Route exact path="/accounts/:id" render={(props) => {
                    isAuthenticated();
                    return <AccountDetails auth={auth} {...props}/>
                }} />
                <Route exact path="/accounts/:accountId/:subscriptionId" render={(props) => {
                    isAuthenticated();
                    return <AccountApiProductDetails auth={auth} {...props}/>
                }} />
                <Route exact path="/page-not-found" render={(props) => {
                    isAuthenticated();
                    return <PageNotFound auth={auth} {...props}/>
                }}/>
                <Route render={() => {
                    isAuthenticated();
                    history.replace('/page-not-found');
                    return null;
                }}/>
            </Switch>
        </Router>
    );
};


// WEBPACK FOOTER //
// ./src/routes.js